// import components
import { Button, styled } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import { WHITE } from 'constants/colors';

export const StyledActionButton = styled(Button)(({ theme }) => ({
  backgroundColor: WHITE,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

export const StyledFontAwesomeSvgIcon = styled(Icon)(({ theme }) => ({
  color: 'inherit',
  fontSize: theme.typography.body1.fontSize
}));
